import { Controller } from "@hotwired/stimulus"

// Replaces a thumbnail-with-play-button (the controller's element's
// child) with an autoplay iframe in the same spot. No modal, no
// navigation — just an in-place swap. Used on the feature show + public
// search result pages so clicking play keeps the user where they are
// inside the same landscape container the thumbnail occupied.
//
// Optional analytics hookup: if the wrapper carries data-media-item-id
// (and optionally data-feature-id), we apply data-controller="media-tracker"
// to the freshly-created iframe so Stimulus boots the existing tracker
// against it. No manual rewire needed.
export default class extends Controller {
  static values = {
    embedUrl: String
  }

  play(event) {
    event?.preventDefault?.()
    if (this._played) return
    this._played = true

    if (!this.embedUrlValue) return

    const iframe = document.createElement("iframe")
    const sep = this.embedUrlValue.includes("?") ? "&" : "?"
    iframe.src = `${this.embedUrlValue}${sep}autoplay=1`
    iframe.className = "w-full h-full"
    iframe.setAttribute("frameborder", "0")
    iframe.setAttribute("allow", "autoplay; fullscreen; picture-in-picture")
    iframe.setAttribute("allowfullscreen", "")

    const mediaItemId = this.element.dataset.mediaItemId
    if (mediaItemId) {
      iframe.setAttribute("data-controller", "media-tracker")
      iframe.setAttribute("data-media-tracker-media-item-id-value", mediaItemId)
      const featureId = this.element.dataset.featureId
      if (featureId) iframe.setAttribute("data-media-tracker-feature-id-value", featureId)
    }

    this.element.replaceChildren(iframe)
  }
}
